import { DateTime, Duration } from "luxon";
import moment from "moment-timezone";
export class NaiveDate {
    static isNaiveDate(a) {
        return a?.isNaiveDate ?? false;
    }
    /// returns new NaiveDate which point local today
    static now(tz) {
        const now = DateTime.now().setZone(tz);
        return new NaiveDate(now.year, now.month, now.day);
    }
    static fromString(s) {
        const splited = s.split("-");
        if (splited.length < 3) {
            return new NaiveDate(-1, -1, -1);
        }
        return new NaiveDate(parseInt(splited[0]), parseInt(splited[1]), parseInt(splited[2]));
    }
    static fromISO(s) {
        return this.fromString(s);
    }
    /// parse yyyymmdd
    static fromEgDtString(input) {
        return new NaiveDate(Number(input.slice(0, 4)), Number(input.slice(4, 6)), Number(input.slice(6, 8)));
    }
    static fromMoment(m) {
        return new NaiveDate(m.year(), m.month() + 1, m.date());
    }
    static fromDateTime(dt) {
        return new NaiveDate(dt.year, dt.month, dt.day);
    }
    /**
     * `Date`로부터 NaiveDate를 생성한다.
     *
     * @param dt
     * @param tz 주어지면 해당 Timezone으로 변환한 뒤에 생성한다.(기본값: system)
     */
    static fromJSDate(dt, tz) {
        const ldt = DateTime.fromJSDate(dt, { zone: tz ?? "system" });
        return NaiveDate.fromDateTime(ldt);
    }
    /**
     * Create NaiveDate from milliseconds. Ignore hour units and smaller.
     *
     * @param dt UNIX Timestamp by milliseconds.
     * @param tz The timezone interpreting `dt`, default: UTC
     */
    static fromMillis(dt, tz) {
        const ldt = DateTime.fromMillis(dt, { zone: tz ?? "UTC" });
        return NaiveDate.fromDateTime(ldt);
    }
    static floorDurationAsDay(duration) {
        return Duration.fromMillis(duration.valueOf() - (duration.valueOf() % 86400));
    }
    static ISO_FORMAT = "yyyy-MM-dd";
    isNaiveDate;
    utc;
    constructor(y, m, d) {
        this.isNaiveDate = true;
        this.utc = DateTime.utc(y, m, d);
    }
    get isValid() {
        return this.utc.isValid;
    }
    get weekday() {
        return this.utc.weekday;
    }
    toString() {
        return this.utc.toFormat(NaiveDate.ISO_FORMAT);
    }
    toISO() {
        return this.toString();
    }
    toMoment(tz) {
        return moment.tz(this.toString(), tz);
    }
    toDateTime(tz) {
        return DateTime.fromFormat(this.toString(), NaiveDate.ISO_FORMAT, {
            zone: tz,
        });
    }
    toJSDate(tz) {
        return this.toDateTime(tz ?? "system").toJSDate();
    }
    toEdDtString() {
        return this.utc.toFormat("yyyyMMdd");
    }
    equals(other) {
        return this.utc.equals(other.utc);
    }
    diff(other) {
        return this.utc.diff(other.utc);
    }
    minus(durationLike) {
        return NaiveDate.fromDateTime(this.utc.minus(durationLike));
    }
    plus(durationLike) {
        const ret = NaiveDate.fromDateTime(this.utc.plus(durationLike));
        return ret;
    }
    clone() {
        return new NaiveDate(this.utc.year, this.utc.month, this.utc.day);
    }
    /**
     * NaiveDate treat as UTC, Returns milliseconds elapsed since January 1, 1970 00:00:00 UTC
     */
    valueOf() {
        return this.utc.valueOf();
    }
}
